import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { FormContainer } from './components/FormContainer';

function App() {
  return (
    <AuthProvider>
      <ProtectedRoute>
        <FormContainer />
      </ProtectedRoute>
    </AuthProvider>
  );
}

export default App;
